export default __webpack_public_path__ + "static/media/diamond-clarity-1@3x.01e11f20.png";